const Socials = [
  {
    icon: "github.svg",
    url: "https://github.com/RIAD-git92",
  },
  {
    icon: "linkedin.svg",
    url: "https://linkedin.com/in/riad-safi-56a64b15a",
  },
  {
    icon: "instagram.svg",
    url: "https://www.instagram.com/riiadz/",
  },
  {
    icon: "facebook.svg",
    url: "https://www.facebook.com/rii.aad.9/",
  },
];

export default Socials;
